import type { FieldDefinition } from '../types.ts';

export const updateFieldsAtPath = (
    fields: FieldDefinition[],
    path: string[],
    updater: (fields: FieldDefinition[]) => FieldDefinition[]
): FieldDefinition[] => {
    if (path.length === 0) return updater(fields);
    const [current, ...rest] = path;
    return fields.map((f) => {
        if (f.name !== current) return f;
        return { ...f, nested_fields: updateFieldsAtPath(f.nested_fields || [], rest, updater) };
    });
};
